import { render, staticRenderFns } from "./phoneOrder.vue?vue&type=template&id=9916c208&scoped=true&"
import script from "./phoneOrder.vue?vue&type=script&lang=js&"
export * from "./phoneOrder.vue?vue&type=script&lang=js&"
import style0 from "./phoneOrder.vue?vue&type=style&index=0&id=9916c208&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9916c208",
  null
  
)

export default component.exports